import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const switchLanguage = (newLang) => {
    if (currentLanguage === newLang) return;

    // Get current URL
    const url = new URL(window.location.href);
    const hostname = window.location.hostname;

    // Check environment type
    const isDev = hostname.includes('localhost') || hostname.includes('afnu-dev');
    const isStaging = hostname.includes('staging.');
    const isProduction = !isDev && !isStaging;

    // Handle subdomain switching for production and staging
    if (isStaging) {
      // Staging: staging.afnu.co.il <-> ar/en/ru.staging.afnu.co.il
      let newHostname = hostname.replace(/^(ar\.|en\.|ru\.)/, ''); // Remove any existing lang prefix

      if (newLang !== 'he') {
        newHostname = `${newLang}.${newHostname}`; // Add new lang prefix
      }

      window.location.href = `${url.protocol}//${newHostname}${url.pathname}${url.search}${url.hash}`;
    } else if (isProduction) {
      // Production: www.afnu.co.il <-> ar/en/ru.afnu.co.il
      let newHostname = hostname.replace(/^(www\.|ar\.|en\.|ru\.)/, ''); // Remove any existing prefix

      if (newLang === 'he') {
        newHostname = `www.${newHostname}`; // Hebrew uses www
      } else {
        newHostname = `${newLang}.${newHostname}`; // Other languages use their code
      }

      window.location.href = `${url.protocol}//${newHostname}${url.pathname}${url.search}${url.hash}`;
    } else {
      // Dev/Localhost: Use query parameter (?lang=he/ar/en/ru)
      const params = new URLSearchParams(url.search);
      params.set('lang', newLang);
      url.search = params.toString();
      window.location.href = url.toString();
    }
  };

  return (
    <div className="language-switcher">
      <button
        className={`lang-btn ${currentLanguage === 'he' ? 'active' : ''}`}
        onClick={() => switchLanguage('he')}
        aria-label="Switch to Hebrew"
        title="עברית"
      >
        עב
      </button>
      <span className="lang-divider">|</span>
      <button
        className={`lang-btn ${currentLanguage === 'ar' ? 'active' : ''}`}
        onClick={() => switchLanguage('ar')}
        aria-label="Switch to Arabic"
        title="العربية"
      >
        عربي
      </button>
      {/* 
      <span className="lang-divider">|</span>
      <button
        className={`lang-btn ${currentLanguage === 'en' ? 'active' : ''}`}
        onClick={() => switchLanguage('en')}
        aria-label="Switch to English"
        title="English"
      >
        EN
      </button>
      <span className="lang-divider">|</span>
      <button
        className={`lang-btn ${currentLanguage === 'ru' ? 'active' : ''}`}
        onClick={() => switchLanguage('ru')}
        aria-label="Switch to Russian"
        title="Русский"
      >
        RU
      </button>
      */}
    </div>
  );
};

export default LanguageSwitcher;
